/* jshint esversion: 6 */
import makeToast from 'app/modules/makeToast.js';
import UserMessages from 'app/modules/UserMessageModule.js';

/**
 * Says how a feed refresh went, once INPUT_REFRESH has settled: the
 * "momentarily" note when the server took it, an error toast when it didn't.
 * A network failure gets no second toast; the app reducer has shown one.
 */
export default function reportInputRefresh(props) {
	let errors = props.getApiErrors(['INPUT_REFRESH']);

	if (!errors.length) {
		props.addMessage(UserMessages.generateMessage(UserMessages.route.created, 'INPUT_REFRESH'));
		return;
	}

	if (!errors[0].isNetworkError) {
		makeToast("", "error", {
			title: "We couldn't check your feed",
			description: "Please try again"
		});
	}
	props.deleteApiError(['INPUT_REFRESH']);
}
